import { trackWindowScroll } from 'react-lazy-load-image-component';
import { PageSegmentsComponent } from './PageSegments';

export const PageSegments = trackWindowScroll(PageSegmentsComponent);
